import React from 'react';

import systemStatuses from 'data/system_statuses';
import billingStatuses from 'data/billing_statuses';

import Actions from './Actions';
// import TrainingStatus from './TrainingStatus';

const columns = (scope) => {
  const arr = [
    {
      name: 'Coach',
      selector: (row) => row.attributes.full_name,
      sortable: true,
    },
    {
      name: 'Created',
      selector: (row) => row.attributes.created_at_int,
      cell: (row) => row.attributes.created_at_formatted,
      sortable: true,
    },
    {
      name: 'Country',
      selector: (row) => row.attributes.country,
      sortable: true,
    },
    {
      name: 'Languages',
      selector: (row) => row.attributes.languages.map((lang) => lang.title).join(', '),
      sortable: true,
    },
    {
      name: 'Email',
      selector: (row) => row.attributes.email,
      sortable: true,
    },
    {
      name: '% of profile',
      selector: (row) => row.attributes.fill_profile,
      sortable: true,
    },
    {
      name: 'Interview',
      selector: (row) => row.attributes.interview_result,
      sortable: true,
    },
    {
      name: 'System Status',
      selector: (row) => row.attributes.status,
      cell: (row) => systemStatuses.find((item) => item.value === row.attributes.status)?.label,
      sortable: true,
    },
    {
      name: 'Billing Status',
      selector: (row) => row.attributes.status_billing,
      cell: (row) => billingStatuses.find((item) => item.value === row.attributes.status_billing)?.label,
      sortable: true,
    },
    {
      name: 'ID Verification',
      selector: (row) => row.attributes.status_verification,
      sortable: true,
    }];

  if (scope === 'request_to_delete') {
    arr.push({
      name: 'Timestamp',
      selector: (row) => row.attributes.request_delete_at_int,
      cell: (row) => row.attributes.request_delete_at_formatted,
      sortable: true,
    });
  }

  arr.push({
    name: ' ',
    sortable: false,
    width: '56px',
    cell: (row) => <Actions row={row} />,
  });

  return arr;
};
export default columns;
